import { Component, Input } from "@angular/core";

export type InlineJobLoadingProgressMode = "indeterminate" | "steps";

export interface InlineJobLoadingStep {
  label: string;
  done: boolean;
  active: boolean;
}

@Component({
  selector: "app-inline-job-loading",
  standalone: false,
  templateUrl: "./inline-job-loading.component.html",
  styleUrl: "./inline-job-loading.component.scss",
})
export class InlineJobLoadingComponent {
  @Input() iconName = "file-text-docx";
  @Input() iconSize = 28;
  @Input() iconColor = "var(--electric-cyan)";

  @Input() title = "";
  @Input() subtitle = "";

  /**
   * Bar fill 0–100. When `progressMode` is `steps`, drives the gradient bar width.
   * Parent updates bind automatically; width uses CSS transition.
   */
  @Input() progressPercent = 0;

  /** Indeterminate: animated bar only. Steps: step list + determinate bar. */
  @Input() progressMode: InlineJobLoadingProgressMode = "steps";

  /** Step rows with done/active flags (parent computes from job / polling state). */
  @Input() steps: InlineJobLoadingStep[] = [];

  /**
   * The job's `expected_completion_at`. When usable, a countdown line
   * ("About 4 min left · ETA 11:22 AM IST") shows under the subtitle.
   */
  @Input() eta: string | number | Date | null | undefined = null;

  get barWidthPercent(): number {
    const p = Number(this.progressPercent);
    if (Number.isNaN(p)) return 0;
    return Math.min(100, Math.max(0, p));
  }
}
